export const industries = [
    'Original Equipment Manufactures (OEMs)',
    'Maintenance,Repair,& Overhaul (MROs)',
    'Medical',
    'Military',
    'Foodservice',
    'Datacenters',
    'Aerospace',
    'DIY & Home Users',
    'Payment CC Images',
    'Copyrights,Etc.',
]
export const about = [
    'Company Info',
    'Blog',
    'FAQs',
    'Terms & Conditions',
    'Shipping & Returns',
    'Privacy',
    'Contact Us',
]

export const services = [
    'Custom Product Design',
    'Custom Fabrication',
    'Custom Handtrucks & Dollies',
    'Warehouse Consulting',
    'Linco Managed Inventory',
]

export const products = ['Casters', 'Handtrucks', 'Carts', 'Caster Sets']
